import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

export const SidebarData = [
    {
        title: "Dashboard",
        path: "/dashboard",
        //path: "",
        /*icon: <AiIcons.AiFillHome/>,*/
        icon:<FaIcons.FaPalette/>,
    },
    {
        title: "Account",
        path: "/account",
        icon: <FaIcons.FaKey />,
        iconClosed: <RiIcons.RiArrowDownSFill/>,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "Add Company",
                path: "/account/company",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Company",
                path: "/account/searchcompany",
                icon: <FaIcons.FaSearch/>,
            },
            {
                title: "Add User",
                path: "/account/add-user",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Users",
                path: "/account/serch-users",
                icon: <FaIcons.FaSearch/>,
            },
        ],
    },
    {
        title: "Equipment Setup",
      /*  path:"/PlantEquipmentSetup/plantequipmentsetup",*/
        path: "",
        icon: <FaIcons.FaRegListAlt/>,
        iconClosed: <RiIcons.RiArrowDownSFill/>,
        iconOpened: <RiIcons.RiArrowUpSFill/>,
        subNav: [
            {
                title: "Plant",
                /* path: "/plantequipmentsetup/companyplant",*/
                path: "/add-plant",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Plants",
                /* path: "/plantequipmentsetup/serchplants",*/
                path: "/search-plant",
                icon: <FaIcons.FaSearch/>,
            },
            {
                title: "Plant Blocks",
                /* path: "/plantequipmentsetup/plantblocks",*/
                path: "/plant-block",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Blocks",
                /* path: "/plantequipmentsetup/serchblocks",*/
                path: "/search-block",
                icon: <FaIcons.FaSearch/>,
            },
            {
                title: "Plant Rows",
                /*path: "/plantequipmentsetup/plantrows",*/
                path: "/plant-row",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Rows",
               ///* path: "/plantequipmentsetup/searchrows",*/
                path: "/search-row",
                icon: <FaIcons.FaSearch/>,
            },
            {
                title: "Plant Controllers",
                /* path: "/plantequipmentsetup/plantcontrollers",*/
                path: "/plant-controller",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Controllers",
                /* path: "/plantequipmentsetup/serchcontrollers",*/
                path: "/search-controller",
                icon: <FaIcons.FaSearch/>,
            },
            {
                title: "Plant Robots",
                /*path: "/plantequipmentsetup/plantrobots",*/
                path: "/plant-robot",
                icon: <FaIcons.FaRegEdit/>,
            },
            {
                title: "Search Robots",
                /*  path: "/plantequipmentsetup/serchrobots",*/
                path: "/search-robot",
                icon: <FaIcons.FaSearch/>,
            },
            {
                title: "Farmer Farm",
                /*path: "/plantequipmentsetup/plantrobots",*/
                path: "/add-farm",
                icon: <FaIcons.FaRegEdit />,
            },
            {
                title: "Search Farms",
                /*  path: "/plantequipmentsetup/serchrobots",*/
                path: "/search-farm",
                icon: <FaIcons.FaSearch />,
            },
        ],
    },
    {
        title: "Equipment Linking",
        /* path: "/equipmentlinkingdetails",*/
        path: "",
        icon: <FaIcons.FaLink/>,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "Block Rows",
                path: "/PlantEquipmentLinking/block-rows",
                icon: <FaIcons.FaLink />,
            },
            {
                title: "Search Block Rows",
                path: "/PlantEquipmentLinking/block-rows",
                icon: <FaIcons.FaLink />,
            },
            {
                title: "Block Controllers",
                path: "/PlantEquipmentLinking/block-controllers",
                icon: <FaIcons.FaLink />,
            },
            {
                title: "Search Block Controllers",
                path: "/PlantEquipmentLinking/search-blockControllers",
                icon: <FaIcons.FaLink />,
            },
            {
                title: "Block Robots",
                path: "/PlantEquipmentLinking/block-robots",
                icon: <FaIcons.FaLink />,
            },
            {
                title: "Search Block Robots",
                path: "/PlantEquipmentLinking/search-blockRobots",
                icon: <FaIcons.FaLink />,
            },
           
        ],
    },
    {
        title: "Operation",
        /* path: "/robotop1",*/
        path: "",
        icon: <AiIcons.AiFillCloud />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "Plant Robot Operation",
                path: "/plant-robot-operation?rid=5&pid=1" ,
                icon: <FaIcons.FaRobot/>,
                cName: "sub-nav",
            },
            {
                title: "Robot Operation",
                path: "/robots-operation?pid=1",
                icon: < FaIcons.FaRobot />,
                cName: "sub-nav",
            },
            {
                title: "Robots Operation",
                path: "/robot-operation",
                icon: < FaIcons.FaRobot />,
                cName: "sub-nav",
            },
            {
                title: "Operation Scheduling",
                /* path: "/operation/ros",*/
                path: "",
                icon: <FaIcons.FaRegEdit/>,
            },
        ],
    },
    {
        title: "Monitoring",
        /*path: "/monitoring",*/
        path: "",
        icon: <AiIcons.AiTwotoneEye/>,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,

        subNav: [
            {
                title: "Current Command Status",
                path: "/current-command-status",
                icon: <AiIcons.AiTwotoneEye/>,
                cName: "sub-nav",
            },
            {
                title: "Robot Operation Status",
                path: "/plant-robots-opn_status",
                icon: <AiIcons.AiTwotoneEye/>,
                cName: "sub-nav",
            },
            {
                title: "Pending Commands",
                path: "/pending-commands-status",
                icon: <AiIcons.AiTwotoneEye/>,
                cName: "sub-nav",
            },
            {
                title: "Completed Commands",
                path: "/completed-commands-status",
                icon: <AiIcons.AiTwotoneEye/>,
                cName: "sub-nav",
            },
            {
                title: "User Logged Status",
                /* path: "/monitoring/userloggedstatus",*/
                path: "",
                icon: <AiIcons.AiTwotoneEye/>,
            },
            {
                title: "Robot Connected Status",
                path: "/robots-broadcast-status",
                icon: <AiIcons.AiTwotoneEye/>,
            },
            {
                title: "Current Plant Level Grass Cutting",
                path: "/current-plant_level-grass-cutting",
                //path: "",
                icon: <AiIcons.AiTwotoneEye/>,
            },
            {
                title: "Current Plant Level Spraying",
                path: "/current-plant-level-spraying",
                //path: "",
                icon: <AiIcons.AiTwotoneEye/>,
            },
            {
                title: "Current Robot Level Grass Cutting",
                path: "/current-plant-level-grass-cutting",
                //path: "",
                icon: <AiIcons.AiTwotoneEye/>,
            },
            {
                title: "Current Robot Level Spraying",
                path: "/current-plant-level-spraying",
                //path: "",
                icon: <AiIcons.AiTwotoneEye/>,
            },
            {
                title: "Current Battery Status",
                path: "/current-battery-status",
                //path: "",
                icon: <AiIcons.AiTwotoneEye />,
            },
        ],
    },
    {
        title: "Reports",
        /* path: "/reports",*/
        path: "",
        icon: <AiIcons.AiOutlineBarChart/>,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,

        subNav: [
            {
                title: "Plant Level Grass Operation",
                path: "/reports/plant-level-operation",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
                cName: "sub-nav",
            },
            {
                title: "Block Level Operation",
                path: "/reports/block-level-operation",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
                cName: "sub-nav",
            },
            {
                title: "Robot Level Operation",
                path: "/reports/robot-level-operation",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
            },
            {
                title: "Plant Level Grass Cutting",
                path: "#/current-plants-level-grass-cutting",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
                cName: "sub-nav",
            },
            {
                title: "Block Level Grasscutting",
                path: "/reports/block-level-grass-cutting",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
                cName: "sub-nav",
            },
            {
                title: "Robot Level Grasscutting",
                path: "#/current-robots-level-grass-cutting",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
            },
            {
                title: "Plant Level Spraying",
                path: "#/current-robot-level-spraying",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
                cName: "sub-nav",
            },
            {
                title: "Block Level Spraying",
                path: "/reports/block-level-spraying",
               //path: "",
                icon: <FaIcons.FaNewspaper/>,
                cName: "sub-nav",
            },
            {
                title: "Robot Level Spraying",
                path: "#/current-robot-level-spraying",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
            },
            {
                title: "Month Level Grass Cutting",
                path: "#/month-level-grass-cutting",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
            },
            {
                title: "Month Level Spraying",
                path: "#/month-level-spraying",
                //path: "",
                icon: <FaIcons.FaNewspaper/>,
            },
        ],
    },
    {
        title: "Robot Location",
        path: "/robot-location",
        icon: <AiIcons.AiTwotoneEnvironment />,
    },
    {
        title: "Weather Status",
        /*  path: "/Infobox",*/
        path: "",
        icon: <AiIcons.AiTwotoneMail/>,
    }
];